import * as Sentry from '@sentry/browser';
import { Component, ErrorInfo, PropsWithChildren } from 'react';
import { getEnvironmentVar } from 'utils';

export class SentryBoundary extends Component<PropsWithChildren> {
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (getEnvironmentVar('REACT_APP_SENTRY_KEY') && getEnvironmentVar('REACT_APP_SENTRY_PROJECT')) {
      Sentry.withScope(scope => {
        scope.setExtra('componentStack', errorInfo.componentStack);
        Sentry.captureException(error);
      });
    }
  }

  render() {
    return this.props.children;
  }
}
